import React from "react";
import { useAuth } from "@/context/AuthContext";
import { Eye } from "lucide-react";

// Batch J Part 1: Viewer (QA) controls — "Preview as" picker (top bar) and the persistent read-only banner.
export function PreviewAsPicker({ dark }) {
  const { user, previewAs, setPreviewAs, isViewer } = useAuth();
  if (!isViewer) return null;
  const opts = [...(user.preview_options || []).map((r) => [`rm:${r}`, r]), ["role:Manager", "Manager view"], ["role:Admin", "Admin view"]];
  if (!opts.some(([v]) => v === previewAs)) opts.unshift([previewAs, previewAs.replace(/^rm:/, "")]);
  return (
    <label className={`flex items-center gap-1.5 text-xs ${dark ? "text-[#E2E2E2]" : "text-foreground"}`} data-testid="preview-as">
      <Eye className="w-3.5 h-3.5" /> Preview as:
      <select value={previewAs} onChange={(e) => setPreviewAs(e.target.value)} data-testid="preview-as-select"
        className={`text-xs rounded-lg px-2 py-1 border ${dark ? "bg-[#333333] text-white border-[#444444]" : "bg-white border-border"}`}>
        {opts.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
    </label>
  );
}

export function ViewerBanner() {
  const { user, isViewer } = useAuth();
  if (!isViewer) return null;
  return (
    <div className="w-full bg-[#F5B71D]/20 border-b border-[#F5B71D]/50 text-[#92600a] text-xs font-medium text-center py-1.5" data-testid="viewer-banner">
      Previewing as {user.preview_label} · read-only
    </div>
  );
}
